var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.803 5.054a.75.75 0 0 1 1.06 1.06L5.06 8.917l2.803 2.804.052.056a.75.75 0 0 1-1.055 1.055l-.057-.05L3.47 9.446a.75.75 0 0 1 0-1.06z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.469 5.054a.75.75 0 0 1 1.06 1.06L9.726 8.917l2.803 2.804.052.056a.75.75 0 0 1-1.055 1.055l-.057-.05-3.333-3.335a.75.75 0 0 1 0-1.06z"
  })));
};
export default Svg16;